<div class="eoi-container">
    <ng-container *ngIf="eoi == 'eoi'">
        <!-- <div class="flex justify-end">
            <button mat-button class="add-button" (click)="addEoi()">
                <mat-icon style="margin-bottom: 2px; width: 16px; height: 16px; font-size: 16px; margin-right: 4px">
                    add
                </mat-icon>
                Add an EOI
            </button>
        </div> -->
        <div class="flex justify-between align-center mt_20">
            <div fxLayout="row" fxLayoutAlign="start center">
                <div style="font-size: 21px;" *ngIf="this.tabService.eoiIndex == 0">Total {{eoiListPendingLength}} EOIS
                </div>
                <div style="font-size: 21px;" *ngIf="this.tabService.eoiIndex == 1">Total {{eoiListApprovedLength}} EOIS
                </div>
                <div style="font-size: 21px;" *ngIf="this.tabService.eoiIndex == 2">Total {{eoiListAllLength}} EOIS
                </div>
            </div>
            <div class="flex align-center">
                <!-- <mat-select [(value)]="selected" class="sort-select">
                    <mat-option *ngFor="let selectUnit of selectList" [value]="selectUnit">
                        {{ selectUnit }}
                    </mat-option>
                </mat-select> -->
                <div class="switch-button-group ml_20" fxLayout="row" fxLayoutAlign="center center">
                    <div class="block_box" fxLayout="row" fxLayoutAlign="center center"
                        [ngClass]="{'active':  layout == 'list'}" (click)="layout='list'">
                        <img src="./assets/images/black/list_{{layout}}.png" class="list_image">
                    </div>
                    <div class="block_box" fxLayout="row" fxLayoutAlign="center center"
                        [ngClass]="{'active':  layout == 'grid'}" (click)="layout='grid'">
                        <img src="./assets/images/black/block_{{layout}}.png" class="list_image">
                    </div>
                </div>
            </div>
        </div>


        <div fxLayout="column" fxLayoutAlign="space-between" class="eoi-content">
            <mat-tab-group mat-align-tabs="start" style="width:100%" [(selectedIndex)]="this.tabService.eoiIndex"
                #childTabs (selectedTabChange)="selectedTabChange($event.index)">
                <mat-tab>
                    <ng-template mat-tab-label>
                        Pending
                        <!-- <span class="tab-count">{{eoiListPendingLength}}</span> -->
                    </ng-template>
                    <div *ngIf="this.tabService.eoiIndex == 0 && layout == 'list'" style="margin-top:24px">
                        <!-- <search-form #formData0 (childResult)="getData($event)" [isStatus]="false"></search-form> -->
                        <table mat-table [dataSource]="eoiList" style="width: 100%;" class="eoi-table">
                            <ng-container matColumnDef="no">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">EOI No.</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.eoiNo}}
                                </td>
                            </ng-container>
                            <!-- <ng-container matColumnDef="submitTime"> -->
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="table-title">Submit time</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                <div  class="table-value">
                                {{element.createTime | date:'HH:mm:ss dd/MM/yyyy'}}</div>
                            </td>
                            <!-- </ng-container> -->
                            <ng-container matColumnDef="agency">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Agency</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div  class="table-value">
                                    <div fxLayout="row" *ngIf="element.agency">

                                        <!-- <img style="width: 20px" *ngIf="element.agency.logo"
                                        src="{{SERVER_URL}}images/company_{{element.agency.id}}/{{element.agency.logo.fileName}}"> -->


                                        <!-- <img style="width: 20px"
                                             src="{{SERVER_URL}}images/company_{{element.agency.id}}/{{element.agency.logo.fileName}}"> -->
                                        <div>{{ element.agency.name }}</div>
                                    </div></div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="agent">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Agent</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div  class="table-value">
                                    <div *ngIf="element.agent" style="display: flex;align-items: center">
                                        <!-- <img style="width: 20px;margin-right: 5px" *ngIf="element.agent.headerUrl"
                                             src="{{SERVER_URL}}images/user_{{element.agent.id}}/{{element.agent.headerUrl}}">
                                        <img style="width: 20px;margin-right: 5px" *ngIf="!element.agent.headerUrl"
                                             src="./assets/images/default-user.svg"> -->
                                        <div>{{ element.agent.firstName }}&nbsp;{{ element.agent.lastName }}</div></div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="buyer">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Buyer</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div  class="table-value"> {{element.buyer.firstName}}&nbsp;{{element.buyer.middleName != "undefined" ?
                                    element.buyer.middleName : ''}} &nbsp; {{element.buyer.lastName}} </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Status</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="table-value eoi-status {{element.status}}">● {{element.status}}</div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="processDate">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Process Date</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div *ngIf="element.processTime != 0" class="table-value">{{element.processTime | date:'HH:mm:ssdd/MM/yyyy'}}</div>
                                    <div *ngIf="element.processTime == 0" class="table-value">-</div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="operation">
                                <th mat-header-cell *matHeaderCellDef>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-icon style="color: #8247FF;font-size:11px;width: 11px;height: 11px;">
                                        arrow_forward
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                            <tr (click)="openEoiDetail(row)" mat-row *matRowDef="let row; columns: displayedColumns;">
                            </tr>
                        </table>
                        <mat-paginator [length]="total" style="background: #000" [pageIndex]="page"
                            [pageSize]="pageSize" (page)="getPageData($event)">
                        </mat-paginator>
                    </div>
                    <div *ngIf="this.tabService.eoiIndex == 0 && layout == 'grid'" style="margin-top:24px">
                        <div class="card-list" *ngFor="let element of eoiList">
                            <div class="card" (click)="openEoiDetail(element)">
                                <div style="font-size: 18px;line-height: 22px;">{{element.eoiNo}}</div>
                                <div class="tx_1">{{ element.agency.name }}</div>
                                <div class="flex" style="width: 100%;">
                                    <div
                                        style="width: 48%;margin-right:4%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Agent</div>
                                        <div class="tx_2">{{ element.agent.firstName }}&nbsp;{{ element.agent.lastName
                                            }}</div>
                                    </div>
                                    <div style="width: 48%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Process Date</div>
                                        <div class="tx_2">
                                            <div *ngIf="element.processTime != 0">{{element.processTime |
                                                date:'dd/MM/yyyy'}}</div>
                                            <div *ngIf="element.processTime == 0">-</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex" style="width: 100%;">
                                    <div
                                        style="width: 48%;margin-right:4%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Buyer</div>
                                        <div class="tx_2">
                                            {{element.buyer.firstName}}&nbsp;{{element.buyer.middleName != "undefined" ?
                                            element.buyer.middleName : ''}}&nbsp;{{element.buyer.lastName}}

                                        </div>
                                    </div>
                                    <div class=""
                                        style="width: 48%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Status</div>
                                        <div class="eoi-status {{element.status}} tx_2">● {{element.status}}</div>
                                    </div>
                                </div>
                                <div class="flex justify-end mt_20">
                                    <div class="tx_1">{{element.createTime | date:'HH:mm:ss dd/MM/yyyy'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        Approved
                        <!-- <span class="tab-count">{{eoiListApprovedLength}}</span> -->
                    </ng-template>
                    <div *ngIf="this.tabService.eoiIndex == 1 && layout == 'list'" style="margin-top:24px">
                        <!-- <search-form #formData1 (childResult)="getData($event)" [isStatus]="false"></search-form> -->
                        <table mat-table [dataSource]="eoiList" style="width: 100%;" class="eoi-table">
                            <ng-container matColumnDef="no">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">EOI No.</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.eoiNo}}
                                </td>
                            </ng-container>
                            <!-- <ng-container matColumnDef="submitTime"> -->
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="table-title">Submit time</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.createTime | date:'HH:mm:ss dd/MM/yyyy'}}
                            </td>
                            <!-- </ng-container> -->
                            <ng-container matColumnDef="agency">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Agency</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div fxLayout="row" *ngIf="element.agency">
                                        <!-- <img style="width: 20px"
                                             src="{{SERVER_URL}}images/company_{{element.agency.id}}/{{element.agency.logo.fileName}}"> -->
                                        <div>{{ element.agency.name }}</div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="agent">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Agent</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div fxLayout="row" *ngIf="element.agent">
                                        <!-- <img style="width: 20px"
                                             src="{{SERVER_URL}}images/user_{{element.agent.id}}/{{element.agent.headerUrl}}"> -->
                                        <div>{{ element.agent.firstName }}&nbsp;{{ element.agent.lastName }}</div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="buyer">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Buyer</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.buyer.firstName}}&nbsp;{{element.buyer.middleName != "undefined" ?
                                    element.buyer.middleName : ''}}&nbsp;{{element.buyer.lastName}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Status</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="eoi-status {{element.status}}">● {{element.status}}</div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="processDate">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Process Date</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div *ngIf="element.processTime != 0">{{element.processTime | date:'HH:mm:ss dd/MM/yyyy'}}</div>
                                    <div *ngIf="element.processTime == 0">-</div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="operation">
                                <th mat-header-cell *matHeaderCellDef>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-icon style="color: #8247FF;font-size:11px;width: 11px;height: 11px;">
                                        arrow_forward
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                            <tr (click)="openEoiDetail(row)" mat-row *matRowDef="let row; columns: displayedColumns;">
                            </tr>
                        </table>
                        <mat-paginator [length]="total" style="background: #000" [pageIndex]="page"
                            [pageSize]="pageSize" (page)="getPageData($event)">
                        </mat-paginator>
                    </div>
                    <div *ngIf="this.tabService.eoiIndex == 1 && layout == 'grid'" style="margin-top:24px">
                        <div class="card-list" *ngFor="let element of eoiList">
                            <div class="card" (click)="openEoiDetail(element)">
                                <div style="font-size: 18px;line-height: 22px;">{{element.eoiNo}}</div>
                                <div class="tx_1">{{ element.agency.name }}</div>
                                <div class="flex" style="width: 100%;">
                                    <div
                                        style="width: 48%;margin-right:4%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Agent</div>
                                        <div class="tx_2">{{ element.agent.firstName }}&nbsp;{{ element.agent.lastName
                                            }}</div>
                                    </div>
                                    <div style="width: 48%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Process Date</div>
                                        <div class="tx_2">
                                            <div *ngIf="element.processTime != 0">{{element.processTime |
                                                date:'dd/MM/yyyy'}}</div>
                                            <div *ngIf="element.processTime == 0">-</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex" style="width: 100%;">
                                    <div
                                        style="width: 48%;margin-right:4%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Buyer</div>
                                        <div class="tx_2">
                                            {{element.buyer.firstName}}{{element.buyer.middleName != "undefined" ?
                                            element.buyer.middleName : ''}}{{element.buyer.lastName}}

                                        </div>
                                    </div>
                                    <div class=""
                                        style="width: 48%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Status</div>
                                        <div class="eoi-status {{element.status}} tx_2">● {{element.status}}</div>
                                    </div>
                                </div>
                                <div class="flex justify-end mt_20">
                                    <div class="tx_1">{{element.createTime | date:'HH:mm:ss dd/MM/yyyy'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label>
                        All
                        <!-- <span class="tab-count">{{eoiListAllLength}}</span> -->
                    </ng-template>
                    <div style="margin-top:24px" *ngIf="this.tabService.eoiIndex == 2 && layout == 'list'">
                        <!-- <search-form #formData2 (childResult)="getData($event)" [isStatus]="true"></search-form> -->
                        <table mat-table [dataSource]="eoiList" style="width: 100%;" class="eoi-table">
                            <ng-container matColumnDef="no">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">EOI No.</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.eoiNo}}
                                </td>
                            </ng-container>
                            <!-- <ng-container matColumnDef="submitTime"> -->
                            <th mat-header-cell *matHeaderCellDef>
                                <div class="table-title">Submit time</div>
                            </th>
                            <td mat-cell *matCellDef="let element">
                                {{element.createTime | date:'HH:mm:ss dd/MM/yyyy'}}
                            </td>
                            <!-- </ng-container> -->

                            <ng-container matColumnDef="agency">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Agency</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div fxLayout="row" *ngIf="element.agency">

                                        <!-- <img style="width: 20px"
                                             src="{{SERVER_URL}}images/company_{{element.agency.id}}/{{element.agency.logo.fileName}}"> -->
                                        <div>{{ element.agency.name }}</div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="agent">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Agent</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div fxLayout="row" *ngIf="element.agent">
                                        <!-- <img style="width: 20px"
                                             src="{{SERVER_URL}}images/user_{{element.agent.id}}/{{element.agent.headerUrl}}"> -->
                                        <div>{{ element.agent.firstName }}&nbsp;{{ element.agent.lastName }}</div>
                                    </div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="buyer">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Buyer</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    {{element.buyer.firstName}}&nbsp;{{element.buyer.middleName != "undefined" ?
                                    element.buyer.middleName : ''}}&nbsp;{{element.buyer.lastName}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Status</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="eoi-status {{element.status}}">● {{element.status}}</div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="processDate">
                                <th mat-header-cell *matHeaderCellDef>
                                    <div class="table-title">Process Date</div>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <div *ngIf="element.processTime != 0">{{element.processTime | date:'HH:mm:ss
                                        dd/MM/yyyy'}}</div>
                                    <div *ngIf="element.processTime == 0">-</div>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="operation">
                                <th mat-header-cell *matHeaderCellDef>
                                </th>
                                <td mat-cell *matCellDef="let element">
                                    <mat-icon style="color: #8247FF;font-size:11px;width: 11px;height: 11px;">
                                        arrow_forward
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns;"></tr>
                            <tr (click)="openEoiDetail(row)" mat-row *matRowDef="let row; columns: displayedColumns;">
                            </tr>
                        </table>
                        <mat-paginator [length]="total" style="background: #000" [pageIndex]="page"
                            [pageSize]="pageSize" (page)="getPageData($event)">
                        </mat-paginator>
                    </div>
                    <div *ngIf="this.tabService.eoiIndex == 2 && layout == 'grid'" style="margin-top:24px">
                        <div class="card-list" *ngFor="let element of eoiList">
                            <div class="card" (click)="openEoiDetail(element)">
                                <div style="font-size: 18px;line-height: 22px;">{{element.eoiNo}}</div>
                                <div class="tx_1">{{ element.agency.name }}</div>
                                <div class="flex" style="width: 100%;">
                                    <div
                                        style="width: 48%;margin-right:4%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Agent</div>
                                        <div class="tx_2">{{ element.agent.firstName }}&nbsp;{{ element.agent.lastName
                                            }}</div>
                                    </div>
                                    <div style="width: 48%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Process Date</div>
                                        <div class="tx_2">
                                            <div *ngIf="element.processTime != 0">{{element.processTime |
                                                date:'dd/MM/yyyy'}}</div>
                                            <div *ngIf="element.processTime == 0">-</div>
                                        </div>
                                    </div>
                                </div>
                                <div class="flex" style="width: 100%;">
                                    <div
                                        style="width: 48%;margin-right:4%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Buyer</div>
                                        <div class="tx_2">
                                            {{element.buyer.firstName}}&nbsp;{{element.buyer.middleName != "undefined" ?
                                            element.buyer.middleName : ''}}&nbsp;{{element.buyer.lastName}}

                                        </div>
                                    </div>
                                    <div class=""
                                        style="width: 48%;border-bottom: 0.5px solid rgba(222, 222, 222, 0.1);">
                                        <div class="tx_1">Status</div>
                                        <div class="eoi-status {{element.status}} tx_2">● {{element.status}}</div>
                                    </div>
                                </div>
                                <div class="flex justify-end mt_20">
                                    <div class="tx_1">{{element.createTime | date:'HH:mm:ss dd/MM/yyyy'}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>

    </ng-container>
    <ng-container *ngIf="eoi == 'detail'">
        <!--        <app-eoi-detail [eoi]="eoiDetail" (closeDetail)="closeDetail()"></app-eoi-detail>-->
        <eoi-detail [eoiId]="eoiDetail.id" (closeDetail)="closeDetail()"></eoi-detail>
    </ng-container>
    <ng-container *ngIf="eoi == 'add'">
        <add-eoi [projectId]="project.id" [project]="project" (closeAdd)="closeAdd($event)"></add-eoi>
    </ng-container>
</div>